import { ProfileCreatePage } from "@features/security/components/ProfileCreatePage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

/**
 * Security — Profile Create Route
 *
 * Form to create a new profile with a permission matrix.
 * Access requires security.profiles.create permission.
 */
export const Route = createFileRoute("/_app/admin/profiles/create")({
  loader: requirePermission(PERMISSIONS.SECURITY.PROFILES.CREATE),
  staticData: {
    title: "Nouveau profil",
    icon: ShieldCheck,
    tab_icon: ShieldCheck,
    permission: PERMISSIONS.SECURITY.PROFILES.CREATE,
    showInNav: false,
    showInBreadcrumb: true,
    description: "Créer un profil",
  },
  component: ProfileCreatePage,
});
